import { floatSub } from './float-operation';

// 获取年月日時分秒
export function dealTime(oldTime) {
  const star = new Date(oldTime);
  const time = star.getFullYear() + '-' + (star.getMonth() + 1) + '-' + star.getDate() + ' ' + star.getHours()
    + ':'
    + star.getMinutes() + ':' + star.getSeconds();
  return time;
}

// 获取年月日時分
export function dealTimeMinute(oldTime) {
  const star = new Date(oldTime);
  const time = star.getFullYear() + '-' + (star.getMonth() + 1) + '-' + star.getDate() + ' ' + star.getHours() + ':' + star.getMinutes();
  return time;
}

// 获取年月日(如：2020-6-7)
export function dealData(oldTime) {
  const star = new Date(oldTime);
  const time = star.getFullYear() + '-' + (star.getMonth() + 1) + '-' + star.getDate();
  return time;
}

// 获取年月日
export function dealMonthDay(oldTime) {
  const star = new Date(oldTime);
  const time = (star.getMonth() + 1) + '月' + star.getDate() + '日';
  return time;
}

// 获取時分秒
export function getTime(oldTime) {
  const star = new Date(oldTime);
  const time = star.getHours() + ':' + star.getMinutes() + ':' + star.getSeconds();
  return time;
}

export function getTimeNoSeconds(oldTime) {
  const star = new Date(oldTime);
  const time = star.getHours() + ':' + star.getMinutes();
  return time;
}

// 獲取小時
export function getHour(oldTime) {
  const star = new Date(oldTime);
  const time = star.getHours().toString();
  return time;
}
// 獲取分鐘
export function getMinute(oldTime) {
  const star = new Date(oldTime);
  const time = star.getMinutes().toString();
  return time;
}

// 算出日期差值
export function subDate(end, start, isAddNum = true) {
  end = dealDate(end);
  start = dealDate(start);
  const endtimes = new Date(end).getTime();
  const starttimes = new Date(start).getTime();
  const intervalTime = floatSub(endtimes, starttimes); // 两个日期相差的毫秒數 一天86400000毫秒

  if (!isAddNum) {
    return Math.ceil(intervalTime / 86400000);
  }

  return Math.ceil(intervalTime / 86400000) + 1; // 加1，是让同一天的两个日期返回一天
}

// 返回两个日期相差的月数
export function MonthsBetw(date1, date2) {
// 用-分成数组
  date1 = date1.split('-');
  date2 = date2.split('-');
// 获取年,月数
  const year1 = parseInt(date1[0], 10);
  const month1 = parseInt(date1[1], 10);
  const year2 = parseInt(date2[0], 10);
  const month2 = parseInt(date2[1], 10);
  return (year2 - year1) * 12 + (month2 - month1) + 1;
}

// 获取年月日时分秒，双位数
export function dealDateTime(oldTime, symbol = '-', withSecond = true) {
  const date = dealDate(oldTime, symbol = '-');
  const time = fetchTime(oldTime, withSecond);
  return date + ' ' + time;
}

// 获取年月日时分秒，双位数，中间用T连接
export function dealDateTimeWithT(oldTime, symbol = '-', withSecond = true) {
  const date = dealDate(oldTime, symbol = '-');
  const time = fetchTime(oldTime, withSecond);
  return date + 'T' + time;
}

// 获取年月日，雙位數
export function dealDate(oldTime, symbol = '-') {
  const star = new Date(oldTime);
  const time = star.getFullYear() + symbol + getMonth(star) + symbol + getDays(star);

  return time;
}

// 获取月日，雙位數
export function dealMonthDate(oldTime, symbol = '-') {
  const star = new Date(oldTime);
  const time = getMonth(star) + symbol + getDays(star);

  return time;
}

// 获取時分秒，雙位數
export function fetchTime(oldTime, withSecond = true) {
  const star = new Date(oldTime);
  let time = getFullHour(star) + ':' + getFullMinute(star);
  if (withSecond) {
    time = time + ':' + getFullSecond(star);
  }

  return time;
}
// 獲取兩位數月
export function getMonth(time) {
  let m = time.getMonth() + 1;
  if (m.toString().length === 1) {
    return m = `0${m}`;
  }

  return m;
}
// 獲取兩位數日期
function getDays(time) {
  let m = time.getDate();
  if (m.toString().length === 1) {
    return m = `0${m}`;
  }

  return m;
}
// 获取两位數小時
function getFullHour(time) {
  let m = time.getHours();
  if (m.toString().length === 1) {
    return m = `0${m}`;
  }

  return m;
}
// 获取两位數分钟
function getFullMinute(time) {
  let m = time.getMinutes();
  if (m.toString().length === 1) {
    return m = `0${m}`;
  }

  return m;
}
// 获取两位數秒數
function getFullSecond(time) {
  let m = time.getSeconds();
  if (m.toString().length === 1) {
    return m = `0${m}`;
  }

  return m;
}

// 获取時分字符串中的小時
// tslint:disable-next-line:ban-types
export function getStringHour(oldTime: String) {
  const time = oldTime.split(':');
  return time[0];
}
// 获取時分字符串中的分钟
// tslint:disable-next-line:ban-types
export function getStringMinute(oldTime: String) {
  const time = oldTime.split(':');
  return time[1];
}

// 不足兩位補零
// tslint:disable-next-line:variable-name
export function toDouble(string) {
  if (string.toString().length === 1) {
    return `0${string}`;
  }
  return string;
}


export function getAge(dateString) {
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

// 獲取 年月日時分秒 例：20190812110201
export function dealDetailedTime(oldTime, symbolA = '-', symbolB = ' ', symbolC = ':') {
  const star = new Date(oldTime);
  const time = star.getFullYear() + symbolA + getMonth(star) + symbolA + getDays(star)
    + symbolB + getFullHour(star) + symbolC + getFullMinute(star) + symbolC + getFullSecond(star);

  return time;
}
// 获取当前日期的00:00
export function getCurrentDateStart(){
  return (new Date().getTime()) -
    (new Date().getHours() * 3600 * 1000) -
    (new Date().getMinutes() * 60 * 1000) -
    (new Date().getSeconds() * 1000
    );
}
// 获取当前日期的23:59
export function getCurrentDateEnd(){
  return (new Date(getCurrentDateStart()).getTime()) + (24 * 3600 * 1000) - (60 * 1000);
}
// 获取日期年月日数据（所有毫秒数）
export function getYearMonthDate(date){
  return new Date(dealData(date)).getTime();
}
// 获取年月（如：202010  sring类型）
export function getYearMonth(date) {
  const star = new Date(date);
  return star.getFullYear() + '' + getMonth(star);
}
// 获取年月日双位数（如：20201101）
export function getYearMonthDay(date) {
  const star = new Date(date);
  return star.getFullYear() + '' + getMonth(star) + getDays(star);
}
// 获取当前月的第几天(day 传几就是几号)
export function getCurrentMonthFirstDay(date, day){
  return date.setDate(day);
}
// 获取当年第一个月
export function getFirstMonthOfYear(date) {
  const star = new Date(date);
  return star.setMonth(0);
}

// 账务年月转成Date类型
export function transBillMonthToDate(billMonth: number | string) {
  const date = String(billMonth);
  const year = date.slice(0, 4);
  const month = date.slice(4);
  let newDate = new Date();
  newDate = new Date(newDate.setFullYear(parseInt(year, 10)));
  newDate = new Date(newDate.setMonth(parseInt(month, 10) - 1, 1));
  return newDate;
}
// 获取年月日時分秒(抄表录入时间处理专用： 2021/4/9 13:36:23)
export function MeterReadingFormatDate(oldTime) {
  const star = new Date(oldTime);
  const time = star.getFullYear() + '/' + (star.getMonth() + 1) + '/' + star.getDate() + ' ' + star.getHours()
    + ':' + star.getMinutes() + ':' + star.getSeconds();
  return time;
}
export function MeterReadExportFormatDate(oldTime) {
  const star = new Date(oldTime);
  const time = star.getFullYear() + '/' + (star.getMonth() + 1) + '/' + star.getDate() + ' ' + (star.getHours() + 8)
    + ':' + star.getMinutes() + ':' + star.getSeconds();
  // return new Date(time);
  return time;
}
// 2020-04-09.142323
export function ExcelDateFormat(oldTime) {
  const star = new Date(oldTime);
  const time = star.getFullYear() + '-' + getMonth(star) + '-' + getDays(star)
    + ' ' + getFullHour(star) + getFullMinute(star) + getFullSecond(star);
  return time;
}

export function handleTime(date, h, m, s) {
  let a = null;
  a = new Date(date.setHours(h));
  a = new Date(date.setMinutes(m));
  a = new Date(date.setSeconds(s));
  return dealDateTime(a);
}

// 获取当前日期的前30天
export function getLast30Day(currentDate) {
  return new Date((currentDate).getTime() - 30 * 24 * 60 * 60 * 1000);
}

// 获取当年第一天
export function getCurrentYearFirstDay(date){
  const year = date.getFullYear();
  return year + '-' + '01' + '-' + '01';
}


export function endOfYesterday(d){
  return new Date().setDate(d.getDate() - 1);
}
export function endOf3day(d){
  return new Date().setDate(d.getDate() - 2);
}
export function endOf7day(d){
  return new Date().setDate(d.getDate() - 6);
}
export function endOf30day(d){
  return new Date().setDate(d.getDate() - 29);
}
export function startOfCurrentMonth(d){
  const fullYear = d.getFullYear();
  const month = d.getMonth();
  return new Date(fullYear, month, 1);
}
export function endOfCurrentMonth(d){
  const fullYear = d.getFullYear();
  const month = d.getMonth() + 1;
  return new Date(fullYear, month, 0);
}
export function endOf3Month(d){
  return new Date().setMonth(d.getMonth() - 3);
}
export function endOf6Month(d){
  return new Date().setMonth(d.getMonth() - 6);
}
export function endOf1Year(d){
  return new Date().setFullYear(d.getFullYear() - 1);
}
